import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
// import { Typography } from '@material-ui/core';

export default function TextBox(props) {
    return props.isDisabled ? (
        <div className="TextBox-disabled">{props.value || 'N/A'}</div>
    ) : (
        <TextField margin="dense" autoComplete="off" fullWidth variant="outlined" inputProps={{ style: { fontWeight: 500 } }} {...props} />
    );
}

export const DatePicker = (props) => {
    const { value, onChange, isDisabled, inputLabel, isRequired, ...rest } = props;

    let [state, setState] = useState({ date: null });

    useEffect(() => {
        setState((st) => ({ ...st, date: props.value == 'Invalid date' ? '--' : props.value }));
    }, [props.value]);
    const handeDateChange = (e) => {
        const { value } = e.target;
        if (value < '2099-12-31') {
            setState((st) => ({ ...st, date: value }));
            props.onChange(e);
        }
    };
    return (
        <TextField
            id="date"
            size="small"
            variant="outlined"
            type="date"
            fullWidth
            inputProps={{
                max: '2099-12-31'
            }}
            onChange={handeDateChange}
            value={state.date}
            {...rest}
            InputLabelProps={{
                shrink: true
            }}
        />
    );
};

export const TextBoxShrink = (props) => {
    return <TextField margin="dense" autoComplete="off" required fullWidth variant="outlined" InputLabelProps={{ shrink: true }} {...props} />;
};

export const DateTimePicker = (props) => {
    const { value, onChange, ...rest } = props;

    let [state, setState] = useState({ date: null });

    useEffect(() => {
        setState((st) => ({ ...st, date: props.value }));
    }, [props.value]);

    const handeDateChange = (e) => {
        const { value } = e.target;
        if (value < '2099-12-31T00:00') {
            setState((st) => ({ ...st, date: value }));
            props.onChange(e);
        }
    };
    return (
        <TextField
            id="datetime-local"
            size="small"
            variant="outlined"
            type="datetime-local"
            fullWidth
            inputProps={{
                max: '2099-12-31T00:00'
            }}
            onChange={handeDateChange}
            value={state.date}
            {...rest}
            InputLabelProps={{
                shrink: true
            }}
        />
    );
};

export const BiggerDisabledText = (props) => (
    <div
        style={{
            width: '100%',
            marginTop: 15,
            fontWeight: 500,
            fontSize: '20px',
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }}
    >
        {props.value}
    </div>
);
